<template>
  <v-container>
    <back-button></back-button>
    <page-heading>{{ pageTitle }}</page-heading>

    <request-state :retry-action="loadAll" :request-promise="requestPromises">
      <v-card>
        <v-card-title>
          {{ transSingular('booking.booking') }}
        </v-card-title>
        <v-card-text>
          <form-input
            :label="transSingular('booking.bookingId')"
            cols="3"
            cols-help="6"
          >
            <template v-slot:input>
              <booking-id :value="booking.id" disable-direct-link />
            </template>
          </form-input>

          <form-input
            :label="transSingular('object.object')"
            cols="3"
            cols-help="6"
          >
            <template v-slot:input>
              <object-name :value="booking"/>
            </template>
          </form-input>
          <form-input
            :label="trans('booking.bookingPeriod')"
            cols="3"
            cols-help="6"
          >
            <template v-slot:input>
              <span>{{ formatDate(booking.checkinAt) }}</span>
              <span class="ml-2 mr-2">-</span>
              <span>{{ formatDate(booking.checkoutAt) }}</span>
            </template>
          </form-input>
        </v-card-text>
      </v-card>

      <guest-card v-if="booking" :guest="booking.guest" class="mt-3" />

      <survey-result-card
        :booking="booking"
        :survey-result="surveyResult"
        class="mt-3"
        :show-view-result-button="false"
        @update="loadSurveyResult"
      />

      <div class="text-h6 mt-8 mb-4">
        {{ trans('survey.surveyResult') }}
      </div>

      <template v-if="surveyResult">
        <survey-result-answer
          v-for="(question, i) in surveyResult.surveyQuestions"
          :key="i"
          class="mb-4"
          :question="question"
          :result-answer="getResultAnswerByQuestion(question)"
          :number="i+1"
          readonly
        />
      </template>
      <info-alert v-else>{{ trans('general.noData') }}</info-alert>
    </request-state>
  </v-container>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import PageHeading from '../components/PageHeading';
import {RouterUtils} from '../utils/router-utils';
import {MainUtils} from '@/utils/main-utils';
import {SurveyApi} from '@/api/survey-api';
import RequestState from '../components/RequestState';
import SurveyResultAnswer from '@/components/survey/SurveyResultAnswer';
import BackButton from '@/components/BackButton';
import {BookingApi} from '@/api/booking-api';
import GuestCard from '@/components/GuestCard';
import InfoAlert from '@/components/InfoAlert';
import {DateUtils} from '@/utils/date-utils';
import SurveyResultCard from '@/components/SurveyResultCard';
import FormInput from '@/components/FormInput';
import ObjectName from '@/components/ObjectName';
import BookingId from '@/components/BookingId';

export default {
  name: 'SurveyResultPage',
  mixins: [
    LocaleUtils,
    RouterUtils,
    MainUtils,
    DateUtils,
  ],
  components: {
    BookingId,
    ObjectName,
    FormInput,
    SurveyResultCard,
    InfoAlert,
    GuestCard,
    BackButton,
    SurveyResultAnswer,
    RequestState,
    PageHeading
  },
  props: {
    bookingId: null
  },
  data: () => ({
    surveyResult: null,
    booking: null,
    surveyResultPromise: null,
    bookingPromise: null,
    requestPromises: null
  }),
  computed: {
    pageTitle () {
      return this.trans('survey.surveyResultForBooking',{bookingId: this.bookingId});
    }
  },
  mounted() {
    this.loadAll();
  },
  methods: {
    loadAll () {
      this.loadSurveyResult();
      this.loadBooking();

      this.requestPromises = Promise.all([
        this.bookingPromise,
        this.surveyResultPromise
      ]);
    },
    loadSurveyResult () {
      let surveyResultPromise = SurveyApi.getSurveyResult(this.bookingId);
      surveyResultPromise.then(value => {
        this.surveyResult = value.body;
      });
      surveyResultPromise.catch(error => {
        this.surveyResult = [];
      })
      this.surveyResultPromise = surveyResultPromise;
    },
    loadBooking () {
      let bookingPromise = BookingApi.getById(this.bookingId);
      bookingPromise.then(response => {
        this.booking = response.data;
      });
      this.bookingPromise = bookingPromise;
    },
    getResultAnswerByQuestion (question) {
      if(this.surveyResult.surveyResultAnswers) {
        for (let i = 0; i < this.surveyResult.surveyResultAnswers.length; i++) {
          let surveyResultAnswer = this.surveyResult.surveyResultAnswers[i];
          if (surveyResultAnswer && surveyResultAnswer.surveyQuestionId === question.id) {
            return surveyResultAnswer;
          }
        }
      }

      return {};
    }
  }
}
</script>

<style>
</style>
